import React, { Component } from 'react';

export default class StartupListWidget extends Component {

    constructor() {
        super();
        this.state = {};
    }

    render() {

        /* for now this is hardcoded, we can find a way in the future to automate these lists */
        return (
            <div className="db-box widget-box">
                <div className="db-header">
                    <div>Startup List</div>
                    <a href={`/startups`} className="seeall">SEE ALL</a>
                </div>
                <div className="widget-box-list">
                    <div className="row">
                        <a className="col-md-5" href={`/en-ae/startups/e-commerce`}>E-Commerce Startups in UAE</a>
                        <a className="col-md-5" href={`/en-sa/startups/fintech`}>Fintech Startups in Saudi Arabia</a>
                        <a className="col-md-5" href={`/en-eg/startups/`}>Startups in Egypt</a>
                        <a className="col-md-5" href={`/en-tr/startups/`}>Startups in Turkey</a>
                        <a className="col-md-5" href={`/en-lb/startups/`}>Startups in Lebanon</a>
                        <a className="col-md-5" href={`/en-ae/startups/e-commerce`}>E-Commerce Startups in UAE</a>
                    </div>
                </div>
            </div>
        )

    }
}
